import { render, staticRenderFns } from "./standingButtonDistributeEdit.vue?vue&type=template&id=3b6553ab&"
import script from "./standingButtonDistributeEdit.vue?vue&type=script&lang=js&"
export * from "./standingButtonDistributeEdit.vue?vue&type=script&lang=js&"
import style0 from "./standingButtonDistributeEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports